<div class="modal-container">
  <div
    class="modal px-2 py-2 bg-white border border-secondary d-flex justify-content-center align-items-center flex-column h-auto rounded"
  >
    <h2 class="title">{{ title }}</h2>
    <p class="body">{{ body }}</p>
    <div class="gap-2 d-flex justify-content-center">
      <button class="btn btn-outline-danger rounded" (click)="closeMe()">
        close
      </button>
      <button (click)="confirmMe()" class="btn btn-outline-primary rounded">
        Confirm
      </button>
    </div>
  </div>
</div>
